(function () {
  /**
   * @ngdoc module
   * @name binky.core.translation-utils
   * @description Module which defines translation utility helpers
   */
  angular.module('binky.core.translation-utils', ['pascalprecht.translate']);
})();
